import React from "react";

interface Props {
  /** Rendered width in px. Height is derived from the logo aspect ratio. */
  width?: number;
  className?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
}

/**
 * Velaro logomark (the "eye") rendered as an inline SVG so the inner dot can
 * be themed. The two swoosh strokes stay white for contrast on every nav
 * accent; the inner circle (the "dot in the middle") uses `--nav-logo-dot`,
 * which each theme defines in main.css with a value that contrasts against
 * that theme's nav background — so we get per-theme "precompiled" dot colors
 * without shipping a separate SVG file per theme.
 */
export default function VelaroLogomark({ width = 28, className, style, onClick }: Props) {
  const height = (width * 95) / 111.49;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 111.49 95"
      width={width}
      height={height}
      className={className}
      style={style}
      onClick={onClick}
      role="img"
      aria-label="Velaro"
    >
      {/* Inner eye circle — the themeable dot */}
      <path
        fill="var(--nav-logo-dot, #2FBF71)"
        d="M55.76,38a9.55,9.55,0,1,1-9.33,9.55A9.45,9.45,0,0,1,55.76,38Z"
      />
      {/* Swoosh strokes — always white for contrast on the nav background */}
      <path
        fill="#fff"
        d="M48.11,91.65C-5.17,54.54,18,30.44,54.13,29,70.48,28.33,71,1.26,53.48,3.48,36.23,5.69-1,20.25,5.83,46.72,11.05,66.85,35.74,87.25,48.11,91.65Z"
      />
      <path
        fill="#fff"
        d="M63.42,3.35c53.27,37.11,30.11,61.21-6,62.67-16.35.65-16.85,27.73.64,25.5,17.25-2.21,54.51-16.77,47.65-43.24C100.48,28.15,75.79,7.75,63.42,3.35Z"
      />
    </svg>
  );
}
